import type { InternalMCPServerNameType } from "@app/lib/actions/mcp_internal_actions/constants";
import { getInternalMCPServerNameFromSId } from "@app/lib/actions/mcp_internal_actions/constants";

// Kept free of server-only imports: the connect UI reads it in the browser.
// Native servers whose tools can run on a Composio-managed connection when the
// user has no native one, so our own OAuth apps need no provider verification.
export const COMPOSIO_TOOLKIT_BY_INTERNAL_SERVER: Partial<
  Record<InternalMCPServerNameType, string>
> = {
  gmail: "googlesuper",
  google_calendar: "googlesuper",
  // googlesuper's Composio-managed app cannot grant Chat scopes.
  google_chat: "google_chat",
  google_drive: "googlesuper",
  google_sheets: "googlesuper",
  outlook: "outlook",
  outlook_calendar: "outlook",
  microsoft_teams: "microsoft_teams",
  microsoft_drive: "one_drive",
  microsoft_excel: "excel",
  github: "github",
  jira: "jira",
  notion: "notion",
};

export function composioToolkitForServer(
  serverName: InternalMCPServerNameType
): string | undefined {
  return COMPOSIO_TOOLKIT_BY_INTERNAL_SERVER[serverName];
}

export function isServerConnectedViaComposio(
  mcpServerId: string,
  activeToolkits: readonly string[]
): boolean {
  const serverName = getInternalMCPServerNameFromSId(mcpServerId);
  const toolkit = serverName ? composioToolkitForServer(serverName) : undefined;
  return !!toolkit && activeToolkits.includes(toolkit);
}
